import { render, staticRenderFns } from "./PerfilSegurancaList.vue?vue&type=template&id=692fab9d&"
import script from "./PerfilSegurancaList.vue?vue&type=script&lang=js&"
export * from "./PerfilSegurancaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports